function stringifySearchParams(searchParams) {
  return new URLSearchParams(searchParams).toString();
}

export function createAbortableFetcher(url, config) {
  let abortController;
  function doFetch(searchParams) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();
    let finalUrl = url;
    if (searchParams) {
      finalUrl += "?";
      if (typeof searchParams === "string") finalUrl += searchParams;
      if (typeof searchParams === "object")
        finalUrl += stringifySearchParams(searchParams);
    }
    return fetch(finalUrl, { ...config, signal: abortController.signal })
      .then(res => res.json())
      .catch(() => {});
  }
  function abortFetch() {
    abortController.abort();
  }
  return [doFetch, abortFetch];
}
